var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOffice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_125_6468)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.075 11.25C11.401 11.25 12.6728 10.7232 13.6105 9.78553C14.5482 8.84785 15.075 7.57608 15.075 6.25C15.075 4.92392 14.5482 3.65215 13.6105 2.71447C12.6728 1.77678 11.401 1.25 10.075 1.25C8.74887 1.25 7.4771 1.77678 6.53942 2.71447C5.60174 3.65215 5.07495 4.92392 5.07495 6.25C5.07495 7.57608 5.60174 8.84785 6.53942 9.78553C7.4771 10.7232 8.74887 11.25 10.075 11.25Z",
    stroke: "#9B9B9B",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.29 26.3099L13.36 33.7499H6.81751L5.56751 23.7499H1.32251V19.9999C1.32284 17.8173 2.13891 15.7135 3.61054 14.1016C5.08217 12.4897 7.1031 11.486 9.2767 11.2875C11.4503 11.089 13.6196 11.71 15.3589 13.0287C17.0982 14.3473 18.2818 16.2684 18.6775 18.4149",
    stroke: "#9B9B9B",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2375 24.925C18.2375 23.7075 19.225 22.72 20.4425 22.72H31.4725C32.69 22.72 33.6775 23.7075 33.6775 24.9275V31.545C33.6775 32.1298 33.4452 32.6906 33.0317 33.1041C32.6182 33.5177 32.0574 33.75 31.4725 33.75H20.4425C19.8577 33.75 19.2969 33.5177 18.8834 33.1041C18.4699 32.6906 18.2375 32.1298 18.2375 31.545V24.925Z",
    stroke: "#9B9B9B",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9399 22.72V21.095C22.9399 20.4319 23.2033 19.796 23.6722 19.3272C24.141 18.8584 24.7769 18.595 25.4399 18.595H26.4699C27.133 18.595 27.7689 18.8584 28.2377 19.3272C28.7066 19.796 28.9699 20.4319 28.9699 21.095V22.72",
    stroke: "#9B9B9B",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_125_6468"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffice);
export default __webpack_public_path__ + "static/media/Office.d48666299863bff1c6c14d816e5e9faf.svg";
export { ForwardRef as ReactComponent };